import { requestWithCustomToken } from "../globals/axios";

const GET_AM_SATELLITE_DATA = "/satellitedata/get-am-satellite-data";
const GET_SEVEN_DAY_IRRIGATION_PLANNER =
  "/satellitedata/get-seven-day-irrigation-planner-v2";
const GET_SOIL_MOISTURE_INSIGHTS =
  "/satellitedata/get-soil-moisture-insights-view";
const GET_CROP_GROWTH_INSIGHTS = "/satellitedata/get-crop-growth-insights-v2";
const GET_AM_SATELLITE_DATA_REPORT_DETAILS =
  "/farmer/get-farm-satellite-data-report-details-v2";

export const getAMSatelliteData = async (farmId, accessKey) => {
  const response = await requestWithCustomToken(
    "get",
    `${GET_AM_SATELLITE_DATA}/${farmId}/`,
    accessKey
  );
  return response.data;
};

export const getAMSatelliteReportDetails = async (
  farmId,
  language,
  accessKey
) => {
  const response = await requestWithCustomToken(
    "get",
    `${GET_AM_SATELLITE_DATA_REPORT_DETAILS}/`,
    accessKey,
    null,
    {
      params: {
        farm_id: farmId,
        ln: language,
      },
    }
  );
  return response.data;
};

export const getSevenDayIrrigationPlanner = async (farmId, accessKey) => {
  const response = await requestWithCustomToken(
    "get",
    `${GET_SEVEN_DAY_IRRIGATION_PLANNER}/${farmId}`,
    accessKey
  );
  return response.data;
};

export const getSoilMoistureData = async (farmId, accessKey) => {
  const response = await requestWithCustomToken(
    "get",
    `${GET_SOIL_MOISTURE_INSIGHTS}/${farmId}`,
    accessKey
  );
  return response.data;
};

export const getCropGrowthData = async (farmId, accessKey) => {
  const response = await requestWithCustomToken(
    "get",
    `${GET_CROP_GROWTH_INSIGHTS}/${farmId}`,
    accessKey
  );
  return response.data;
};
